import { Logo } from '@/components/Logo';
import { Button } from '@/components/ui/button';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import { validatePhoneNumber } from '@/utils/phoneValidation';
import { PhoneNumberInput } from '@/components/invite-guests/phone-input/PhoneNumberInput';
const Login = () => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const checkSession = async () => {
      const {
        data: {
          session
        }
      } = await supabase.auth.getSession();
      if (session) {
        navigate('/home');
      }
    };
    checkSession();
    if (location.state?.phoneNumber) {
      setPhoneNumber(location.state.phoneNumber);
    }
  }, [navigate, location.state]);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      if (!validatePhoneNumber(phoneNumber)) {
        throw new Error('Please enter a valid phone number with country code');
      }
      const {
        data: existingUser,
        error: checkError
      } = await supabase.from('users').select('user_id').eq('phone_number', phoneNumber).maybeSingle();
      if (checkError) throw checkError;
      if (existingUser) {
        const {
          error: otpError
        } = await supabase.auth.signInWithOtp({
          phone: phoneNumber,
          options: {
            shouldCreateUser: false
          }
        });
        if (otpError) throw otpError;
        toast.success('Verification code sent to your phone!');
        navigate('/verify', {
          state: {
            phoneNumber: phoneNumber,
            mode: 'login'
          }
        });
        return;
      }
      navigate('/signup', {
        state: {
          phoneNumber: phoneNumber
        }
      });
      toast.info('No account found. Please sign up.');
    } catch (error: any) {
      console.error('Login error:', error);
      toast.error(error.message || 'Failed to process login. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };
  return <div className="min-h-screen flex flex-col items-center justify-center p-6 animate-fade-in">
      <div className="w-full max-w-sm flex flex-col items-center">
        <Logo variant="dark" />
        <h1 className="text-2xl font-bold mt-8 mb-2 text-center py-[32px]">Welcome back</h1>
        
        
        <form onSubmit={handleSubmit} className="space-y-4 w-full">
          <div>
            <PhoneNumberInput value={phoneNumber} onChange={setPhoneNumber} required centerAlign />
            
          </div>
          
          <Button className="w-full" size="lg" type="submit" disabled={isLoading}>
            {isLoading ? 'Sending code...' : 'Send code'}
          </Button>
        </form>

        <div className="mt-6 text-center">
          <p className="text-gray-600">
            <Link to="/signup" className="text-primary font-medium hover:underline">
              Sign up
            </Link>
          </p>
        </div>
      </div>
    </div>;
};
export default Login;